export const isDev = import.meta.env.MODE === 'development';

export const getStructure = (node, depth = 0, prefix = '') => {
    const { type: nodeType, children } = node;
    let structure = `${prefix}${nodeType}\n`;
    if (!nodeType) return '';

    const newPrefix = prefix.replace(/└─$/, '   ').replace(/├─$/, '│  ');
    if (children && children.length > 0) {
        children.forEach((child, index) => {
            const isLast = index === children.length - 1;
            structure += getStructure(
                child,
                depth + 1,
                newPrefix + (isLast ? '└─' : '├─'),
            );
        });
    }
    return structure;
};
